export function getDatabaseCellConversationKey(databaseItemId: string, databasePropertyId: string): string {
  return `${databasePropertyId}-${databaseItemId}`
}
